import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fl py-16 max-w-md" data-testid="forgot-password-page">
      <h1 className="text-3xl font-black tracking-tighter mb-2">Forgot your password?</h1>
      <p className="text-neutral-500 text-sm mb-8">
        Enter the email on your FitLink account and we'll send you a link to reset it.
      </p>

      {done ? (
        <div
          data-testid="forgot-password-success"
          className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800"
        >
          If an account exists for <strong>{email}</strong>, we've just sent a reset link.
          The link expires in 1 hour. Check your inbox (and spam folder).
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-neutral-500">Email</label>
            <input
              data-testid="forgot-password-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 h-12 w-full rounded-md border border-neutral-200 px-3 outline-none focus:border-neutral-900"
            />
          </div>
          {error && (
            <div data-testid="forgot-password-error" className="text-sm text-red-600">
              {error}
            </div>
          )}
          <button
            data-testid="forgot-password-submit"
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
          >
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}

      <div className="text-sm text-neutral-500 mt-6">
        Remembered it?{" "}
        <Link to="/login" className="text-emerald-700 font-semibold">
          Back to log in
        </Link>
      </div>
    </div>
  );
}
